import { makeTable } from "../utils/tables";
import random from "lodash/random";

export const looks = makeTable("looks", [
  { name: "Flamboyant robes in reflective materials" },
  { name: "Torn, old space dock jacket" },
  { name: "Foreign, realistic tattoos" },
  { name: "Filthy, dark makeup" },
  { name: "Undersized hologlasses" },
  { name: "Perfectly weathered clothes" },
  { name: "Botany patches on arms and back saying “I love plants”" },
  { name: "Fashionable interstellar clothes" },
  { name: "Too clean civilian clothes" },
  {
    name: "Bags and pockets everywhere for everything but never anything important in them",
  },
  { name: "Layers of black fabric, wrapped loosely" },
  { name: "Robotic", variants: ["Robotic hands", "Robotic arms"] },
  {
    name: "{bulletScars, plural, one {A bullet scar} other {# bullet scars}}, {scarsFromSlashingWeapons, plural, one {a scar from a slashing weapon} other {# scars from slashing weapons}}, and {metalFragments, plural, one {a metal fragment} other {# metal fragments}}",
    getValues: () => ({
      bulletScars: random(1, 6),
      scarsFromSlashingWeapons: random(1, 4),
      metalFragments: random(1, 4),
    }),
  },
  { name: "Asymmetric, patterned hood" },
  { name: "Antique space gloves" },
  { name: "Hazard pants" },
  { name: "Trucker cap with patch" },
  { name: "Necklace with odd animal skulls" },
  { name: "Decorated cape" },
  { name: "Suit with holographic patterns" },
]);
